export const basePath = '/insights/ask-ai'

const askAIRoutes = {
  root: basePath,
}

export default askAIRoutes
